'use strict';

var models = require('./models.cjs');

const DAY_OF_WEEKS = [
  models.DayOfWeek.Mon,
  models.DayOfWeek.Tue,
  models.DayOfWeek.Wed,
  models.DayOfWeek.Thu,
  models.DayOfWeek.Fri,
  models.DayOfWeek.Sat,
  models.DayOfWeek.Sun
];
const ISO_TIME_ZONE_OFFSET_FORMAT = "XXX";
const ISO_DATE_PART_FORMAT = "yyyy-MM-dd";
const ISO_DATE_PART_WITHOUT_DAY_FORMAT = "yyyy-MM";
const ISO_TIME_PART_FORMAT = "HH:mm:ss";
const ISO_DATE_TIME_PART_FORMAT = `${ISO_DATE_PART_FORMAT}'T'${ISO_TIME_PART_FORMAT}`;
const ISO_FULL_FORMAT = `${ISO_DATE_PART_FORMAT}'T'${ISO_TIME_PART_FORMAT}${ISO_TIME_ZONE_OFFSET_FORMAT}`;
const DEFAULT_END_DATE_ALTERNATIVE = "";

exports.DAY_OF_WEEKS = DAY_OF_WEEKS;
exports.DEFAULT_END_DATE_ALTERNATIVE = DEFAULT_END_DATE_ALTERNATIVE;
exports.ISO_DATE_PART_FORMAT = ISO_DATE_PART_FORMAT;
exports.ISO_DATE_PART_WITHOUT_DAY_FORMAT = ISO_DATE_PART_WITHOUT_DAY_FORMAT;
exports.ISO_DATE_TIME_PART_FORMAT = ISO_DATE_TIME_PART_FORMAT;
exports.ISO_FULL_FORMAT = ISO_FULL_FORMAT;
exports.ISO_TIME_PART_FORMAT = ISO_TIME_PART_FORMAT;
exports.ISO_TIME_ZONE_OFFSET_FORMAT = ISO_TIME_ZONE_OFFSET_FORMAT;
//# sourceMappingURL=constants.cjs.map
